import { getColorsCSS, getBorderCSS, getShadowCSS, getSpaceCSS, getTypoCSS } from '../../Components/Helper/getCSS';

const Style = ({ attributes, clientId }) => {
	const { width, alignment, textAlign, typography, colors, padding, border, shadow } = attributes;

	const alertSl = `#abbAlertBox-${clientId} .abbAlertBox`;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${getTypoCSS('', typography)?.googleFontLink}
		${getTypoCSS(`${alertSl} .alert`, typography)?.styles}

		${alertSl}{
			text-align: ${alignment};
		}
		${alertSl} .alert{
			text-align: ${textAlign};
			width: ${'0px' === width || '0%' === width || '0em' === width ? 'auto' : width};
			${getColorsCSS(colors)}
			padding: ${getSpaceCSS(padding)};
			${getBorderCSS(border)}
			box-shadow: ${getShadowCSS(shadow)};
		}
		${alertSl} .alert .alertIcon{
			font-size: ${typography?.fontSize};
			color: ${colors?.color};
		}
		${alertSl} .alert .alertClose{
			color: ${colors?.color};
		}
		`.replace(/\s+/g, ' ')
	}} />;
}
export default Style;